import { useState, type ReactNode } from 'react';
import { useT } from '../../i18n/i18n';

// − n + count control. Field rule: numbers are adjusted, never typed.
export function CountStepper(props: { value: number; min?: number; max?: number; onChange: (value: number) => void; label?: string; testId?: string }) {
  const { t } = useT();
  const min = props.min ?? 0;
  const max = props.max ?? 99;
  const label = props.label ?? '';
  return (
    <div className="stepper" data-testid={props.testId}>
      <button
        type="button"
        className="stepper-btn"
        aria-label={t('common.decrease', { label })}
        disabled={props.value <= min}
        onClick={() => props.onChange(Math.max(min, props.value - 1))}
        data-testid={props.testId ? `${props.testId}-minus` : undefined}
      >
        −
      </button>
      <span className="stepper-value" aria-live="polite" data-testid={props.testId ? `${props.testId}-value` : undefined}>
        {props.value}
      </span>
      <button
        type="button"
        className="stepper-btn"
        aria-label={t('common.increase', { label })}
        disabled={props.value >= max}
        onClick={() => props.onChange(Math.min(max, props.value + 1))}
        data-testid={props.testId ? `${props.testId}-plus` : undefined}
      >
        +
      </button>
    </div>
  );
}

// Collapsible block with a one-line summary: the summary is the fast read, the body is one
// tap away. Used for the per-floor room counts on the new-inspection form.
export function Disclosure(props: { title: string; summary: string; children: ReactNode; defaultOpen?: boolean; testId?: string }) {
  const { t } = useT();
  const [open, setOpen] = useState(props.defaultOpen ?? false);
  return (
    <div className="disclosure" data-testid={props.testId} data-open={open ? 'true' : 'false'}>
      <button type="button" className="disclosure-head" aria-expanded={open} onClick={() => setOpen((v) => !v)}>
        <span className="disclosure-title">{props.title}</span>
        <span className="disclosure-summary">{props.summary}</span>
        <span className="disclosure-chevron">{open ? t('common.collapse') : t('common.adjust')}</span>
      </button>
      {open ? <div className="disclosure-body">{props.children}</div> : null}
    </div>
  );
}
